'use client';

import { createSlice } from '@reduxjs/toolkit';
import { TServices } from '../../constants';

const initialState = {
	selectionType: [
		{
			custNumber: '',
			dateSubmitted: '',
			status: '',
			sumCost: 0,
			dateRequired: '',
			productId: '',
			productName: '',
			productPrice: '0.00',
			currencyCode: '',
			custName: '',
			position: '',
			address: '',
			customerName: '',
			email: '',
			phoneNumber: '',
			postalCode: '',
			areaID: '',
		},
	],
};

const serviceRequestSlice = createSlice({
	name: 'serviceRequest',
	initialState,
	reducers: {
		changeSelectionType: (state, action) => {
			state.selectionType = action.payload;
		},
	},
});

export const { changeSelectionType } = serviceRequestSlice.actions;
export default serviceRequestSlice.reducer;
